import { FilterTabs } from "@components/pageHeader/filters/lib";

export const FORM_1099_FILTER_TABS: FilterTabs[] = [
    FilterTabs.AMOUNT,
    FilterTabs.ELIGIBLE_1099,
    FilterTabs.JOURNAL_ENTRY_SOURCES,
    FilterTabs.LEDGER_GROUP,
    FilterTabs.COUNTERPARTY_CREATED_BY,
];
